exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings__item[data-v-25112c36] {\n  margin-bottom: 24px;\n}\n.settings__item-header[data-v-25112c36] {\n  margin-bottom: 16px;\n}\n.settings__logout-icon[data-v-25112c36] {\n  margin-bottom: 24px;\n}\n.settings__logout-text[data-v-25112c36] {\n  margin: 16px 0;\n  color: #578AD6;\n}\n.settings .md-list.md-theme-default[data-v-25112c36] {\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n}\n.settings-dialog__content[data-v-25112c36] {\n  margin: 24px 0;\n}\n.settings-dialog__description[data-v-25112c36] {\n  margin: 16px 0;\n  color: #578AD6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25112c36","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/settings/security/Security.ChangePassword.vue
// module id = bxhB
// module chunks = 1